import { productPartNumbersStyles as styles } from "@insite/content-library/Components/ProductPartNumbers";
import { IconWrapper } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { commonInputIcons, commonLinkStyles, customLinkHoverStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

const commonLabelStyles: TypographyPresentationProps = {
    color: colorStrings.commonGlobalGrayText,
    weight: "bold",
    css: css`
        font-size: 16px;
    `,
    size: 16,
};

const commonTextStyles: TypographyPresentationProps = {
    color: colorStrings.commonGlobalGrayText,
    size: 16,
    weight: "normal",
    css: css`
        font-size: 16px;
    `,
};

const commontTextGridItemStyles = {
    css: css`
        display: flex;
        gap: 0 5px;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
    `,
};

styles.erpNumberLabelText = {
    ...styles.erpNumberLabelText,
    ...commonLabelStyles,
};

styles.customerNameLabelText = {
    ...styles.customerNameLabelText,
    ...commonLabelStyles,
};

styles.manufacturerItemLabelText = {
    ...styles.manufacturerItemLabelText,
    ...commonLabelStyles,
};

styles.erpNumberValueText = {
    ...styles.erpNumberValueText,
    ...commonTextStyles,
};

styles.customerNameValueText = {
    ...styles.customerNameValueText,
    ...commonTextStyles,
};

styles.manufacturerItemValueText = {
    ...styles.manufacturerItemValueText,
    ...commonTextStyles,
};

styles.erpNumberGridItem = {
    ...styles.erpNumberGridItem,
    ...commontTextGridItemStyles,
};

styles.manufacturerItemGridItem = {
    ...styles.manufacturerItemGridItem,
    ...commontTextGridItemStyles,
};

styles.customerNameGridItem = {
    ...styles.customerNameGridItem,
    ...commontTextGridItemStyles,
};
